export const AUTO_SAVE_INTERVAL = 30000;
export const AUTO_SAVE_CLEAR_DELAY = 2000;

export const DOMAIN_SETTINGS_URL = '/app/miscSetting/itemWrapper?systemId=nav.marketing&settingModuleName=Marketing&settingTabName=landingpage.settings.title';
export const UNLAYER_BUILDER_CUSTOMIZATION_HELP_URL = 'https://help.keap.com/help/broadcast-customize-a-broadcast-new-email-builder';

export const SOURCES = Object.freeze({
    CAMPAIGN: 'CAMPAIGN',
    BROADCAST: 'BROADCAST',
});

export const UNLAYER_EMAIL_BROADCAST_WIZARD_STAGE_INDEXES = {
    TEMPLATE: 0,
    CREATE: 1,
};

export const EDITOR_VERSION = '1.455.0';
export const CUSTOM_TOOLS_BASE_URL = 'https://storage.googleapis.com/is-unlayer-tools.appspot.com/builds';
export const customToolsUri = `${CUSTOM_TOOLS_BASE_URL}/keap-unlayer-email-tools-5.1.1.js`;
